// Public site of a salon: https://{subDomain}.padix.ir (same address the navbar links to).
// VITE_SITE_BASE_DOMAIN can point another environment at its own domain.
const siteBaseDomain = import.meta.env.VITE_SITE_BASE_DOMAIN || "padix.ir";

export const merchantSiteUrl = (subDomain?: string | null) =>
  subDomain ? `https://${subDomain}.${siteBaseDomain}` : "";
